import type { NextRouter } from 'next/router';
import { ME } from '@engage/members/models';
import {
  toProfileWorkoutsPath,
  toMemberWorkoutsPath,
  PROFILE_WORKOUTS_ROUTE_REGEX,
  MEMBER_WORKOUTS_ROUTE_REGEX,
} from '@engage/overview';

export { PROFILE_WORKOUTS_ROUTE_REGEX, MEMBER_WORKOUTS_ROUTE_REGEX };

export const LEGACY_WORKOUTS_ROUTE = '/workouts/:workoutId?';
export const SHAREABLE_WORKOUTS_ROUTES = '/share/workouts/:shareWorkoutId';

export const toWorkoutDetailsPath = (isMe: boolean, workoutId: string, userId?: string) =>
  isMe
    ? toProfileWorkoutsPath({ workoutId })
    : toMemberWorkoutsPath({ userId, workoutId });

const matchWorkoutsPath = (path: string): boolean =>
  PROFILE_WORKOUTS_ROUTE_REGEX.test(path) || MEMBER_WORKOUTS_ROUTE_REGEX.test(path);

export const getViewedMemberIdFromPath = (router: NextRouter) => {
  const pathMatch = matchWorkoutsPath(router.asPath);
  if (pathMatch) {
    return router.query.memberId ?? ME;
  } else {
    return undefined;
  }
};

export const isWorkoutsPath = (path: string) => matchWorkoutsPath(path);

export const isWorkoutHistoryPath = (router: NextRouter) => {
  const pathMatch = matchWorkoutsPath(router.asPath);
  return pathMatch && !router.query.workoutId;
};
